import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import Theme from '../../components/Button';
// mock
import EditarVendaForm from '../FormsTemplates/Venda/EditarVendaForms';
import EditarVendaAgenciaViagemForm from '../FormsTemplates/Venda/EditarVendaAgenciaViagemForms';

export default function EditarVenda() {

  const validaTipoComercio = localStorage.getItem(['tipo_comercio']);
  const tipoComercio = parseInt(validaTipoComercio, 10);
  let EditarVenda = EditarVendaForm;

  if (tipoComercio === 5) {
    EditarVenda = EditarVendaAgenciaViagemForm;
  }else {
    EditarVenda = EditarVendaForm;
  }
  
  return (
    <Page title="Venda">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alterar Venda
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/venda/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <EditarVenda/>    
      </Container>
    </Page>
  );
}
